import { taggedTemplateLiteral as _taggedTemplateLiteral, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled, { css } from 'styled-components';
import InlineSVG from '../../_virtual/index.js';
import searchIcon from '../../assets/icons/icon-search-inactive.js';
import shopIcon from '../../assets/icons/icon-shop.js';
import emailIcon from '../../assets/icons/icon-email.js';
import contactIcon from '../../assets/icons/icon-contact.js';
import cancelIcon from '../../assets/icons/icon-cancel.js';
import myAccountIcon from '../../assets/icons/icon-user.js';
import addressIcon from '../../assets/icons/icon-address.js';
import flagIcon from '../../assets/icons/icon-flag.js';
import locationIcon from '../../assets/icons/icon-location.js';
import visibilityOnIcon from '../../assets/icons/icon-visibility-on.js';
import editIcon from '../../assets/icons/icon-edit.js';
import hamburgerIcon from '../../assets/icons/icon-hamburger.js';
import searchIconMobile from '../../assets/icons/icon-search-mobile.js';
import playIcon from '../../assets/icons/icon-play.svg.js';
import playIconWhite from '../../assets/icons/icon-white-play.js';
import eduIcon from '../../assets/icons/icon-education.js';
import toolsIcon from '../../assets/icons/icon-tools.js';
import membershipIcon from '../../assets/icons/icon-membership.js';
import aboutConsultantsIcon from '../../assets/icons/about-consultants-icon.js';
import caseStudiesIcon from '../../assets/icons/case-studies-icon.js';
import connectCandidatesIcon from '../../assets/icons/connect-candidates-icon.js';
import employerResourcesIcon from '../../assets/icons/employer-resources-icon.js';
import ballIronIcon from '../../assets/icons/ball-iron-icon.js';
import warningIcon from '../../assets/icons/warning-icon.js';
import closeIcon from '../../assets/icons/icon-close.js';
import externalLink from '../../assets/icons/externalLink.js';
import trashIcon from '../../assets/icons/icon-trash.js';
import infoIcon from '../../assets/icons/icon-info.js';
import calendarIcon from '../../assets/icons/icon-calendar.js';
import clockIcon from '../../assets/icons/icon-clock.js';
import golfBallIcon from '../../assets/icons/icon-golf-ball.js';
import globeIcon from '../../assets/icons/icon-globe.js';
import entryFeeIcon from '../../assets/icons/icon-entry-fee.js';
import captionIcon from '../../assets/icons/caption-icon.js';
import trophyIcon from '../../assets/icons/icon-trophy.js';
import backArrowIcon from '../../assets/icons/backArrow.js';
import greenSuccess from '../../assets/icons/icon-green-check.js';
import briefcaseCheckIcon from '../../assets/icons/icon-briefcase-checked.js';
import briefcaseGolfIcon from '../../assets/icons/icon-briefcase-golf.js';
import preferencesIcon from '../../assets/icons/icon-preferences.js';
import instagramIcon from '../../assets/icons/icon-instagram.js';
import websiteIcon from '../../assets/icons/website-icon.js';
import FbSvg from '../../assets/icons/fb.js';
import InSvg from '../../assets/icons/in.js';
import TwitterSvg from '../../assets/icons/twitter.js';
import GSvg from '../../assets/icons/g.js';
import YoutubeSvg from '../../assets/icons/youtube.js';
import emailErrorIco from '../../assets/icons/email-error-icon.js';
import emailSentIco from '../../assets/icons/email-sent-icon.js';
import errorTriangleIco from '../../assets/icons/error-triangle-icon.js';
import searchJobsIcon from '../../assets/icons/icon-search.js';
import execusearchIcon from '../../assets/icons/execusearch-ico.js';
import searcIconhBlue from '../../assets/icons/icon-search-blue.js';
import meetTeamIcon from '../../assets/icons/meet-team-ico.js';
import onlineEducationIcon from '../../assets/icons/online-education-ico.js';
import gmailIcon from '../../assets/icons/gmail-icon.js';

var _templateObject, _templateObject2, _templateObject3;
var iconStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 5px 10px;\n  cursor: pointer;\n"])));
var IcoSvg = styled(InlineSVG)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), iconStyles, function (_ref) {
  var pt = _ref.pt;
  return pt && "padding-top: ".concat(pt, "px");
}, function (_ref2) {
  var pr = _ref2.pr;
  return pr && "padding-right: ".concat(pr, "px");
}, function (_ref3) {
  var pb = _ref3.pb;
  return pb && "padding-bottom: ".concat(pb, "px");
}, function (_ref4) {
  var pl = _ref4.pl;
  return pl && "padding-left: ".concat(pl, "px");
}, function (_ref5) {
  var pointer = _ref5.pointer;
  return pointer && "cursor: pointer;";
});
var LinkIconDefinition = styled.i.attrs({
  className: "fa fa-angle-right"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), iconStyles);
LinkIconDefinition.displayName = "LinkIcon";
var LinkIcon = LinkIconDefinition;
var SearchIconDefinition = function SearchIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: searchIcon,
    alt: "search"
  }, props));
};
SearchIconDefinition.displayName = "SearchIcon";
var SearchIcon = SearchIconDefinition;
var ShopIconDefinition = function ShopIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: shopIcon,
    alt: "shop"
  }, props));
};
ShopIconDefinition.displayName = "ShopIcon";
var ShopIcon = ShopIconDefinition;
var EmailIconDefinition = function EmailIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: emailIcon,
    alt: "email"
  }, props));
};
EmailIconDefinition.displayName = "EmailIcon";
var EmailIcon = EmailIconDefinition;
var ContactIconDefinition = function ContactIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: contactIcon,
    alt: "contact"
  }, props));
};
ContactIconDefinition.displayName = "ContactIcon";
var ContactIcon = ContactIconDefinition;
var CancelIconDefinition = function CancelIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: cancelIcon,
    alt: "cancel"
  }, props));
};
CancelIconDefinition.displayName = "CancelIcon";
var CancelIcon = CancelIconDefinition;
var AddressIconDefinition = function AddressIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: addressIcon,
    alt: "contact"
  }, props));
};
AddressIconDefinition.displayName = "AddressIcon";
var AddressIcon = AddressIconDefinition;
var FlagIconDefinition = function FlagIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: flagIcon,
    alt: "contact"
  }, props));
};
FlagIconDefinition.displayName = "FlagIcon";
var FlagIcon = FlagIconDefinition;
var LocationIconDefinition = function LocationIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: locationIcon,
    alt: "contact"
  }, props));
};
LocationIconDefinition.displayName = "LocationIcon";
var LocationIcon = LocationIconDefinition;
var UserIconDefinition = function UserIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: myAccountIcon,
    alt: "contact"
  }, props));
};
UserIconDefinition.displayName = "UserIcon";
var UserIcon = UserIconDefinition;
var VisibilityOnIconDefinition = function VisibilityOnIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: visibilityOnIcon,
    alt: "contact"
  }, props));
};
VisibilityOnIconDefinition.displayName = "VisibilityOnIcon";
var VisibilityOnIcon = VisibilityOnIconDefinition;
var EditIconDefinition = function EditIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: editIcon,
    alt: "edit"
  }, props));
};
EditIconDefinition.displayName = "EditIcon";
var EditIcon = EditIconDefinition;
var FbIconDefinition = function FbIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: FbSvg,
    alt: "Facebook"
  }, props));
};
FbIconDefinition.displayName = "FacebookIcon";
var FbIcon = FbIconDefinition;
var GIconDefinition = function GIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: GSvg,
    alt: "Google"
  }, props));
};
GIconDefinition.displayName = "GoogleIcon";
var GIcon = GIconDefinition;
var InIconDefinition = function InIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: InSvg,
    alt: "Linkedin"
  }, props));
};
InIconDefinition.displayName = "LinkedInIcon";
var InIcon = InIconDefinition;
var TwitterIconDefinition = function TwitterIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: TwitterSvg,
    alt: "Twitter"
  }, props));
};
TwitterIconDefinition.displayName = "TwitterIcon";
var TwitterIcon = TwitterIconDefinition;
var YoutubeIconDefinition = function YoutubeIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: YoutubeSvg,
    alt: "Youtube"
  }, props));
};
YoutubeIconDefinition.displayName = "YoutubeIcon";
var YoutubeIcon = YoutubeIconDefinition;
var HamburgerIconDefinition = function HamburgerIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: hamburgerIcon,
    alt: "hamburger"
  }, props));
};
HamburgerIconDefinition.displayName = "HamburgerIcon";
var HamburgerIcon = HamburgerIconDefinition;
var SearchIconMobileDefinition = function SearchIconMobileDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: searchIconMobile,
    alt: "search"
  }, props));
};
SearchIconMobileDefinition.displayNameDefinition = "SearchIconMobile";
var SearchIconMobile = SearchIconMobileDefinition;
var PlayIconDefinition = function PlayIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: playIcon,
    alt: "play"
  }, props));
};
PlayIconDefinition.displayName = "PlayIcon";
var PlayIcon = PlayIconDefinition;
var EduIconDefinition = function EduIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: eduIcon,
    alt: "education"
  }, props));
};
EduIconDefinition.displayName = "EduIcon";
var EduIcon = EduIconDefinition;
var ToolsIconDefinition = function ToolsIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: toolsIcon,
    alt: "tools"
  }, props));
};
ToolsIconDefinition.displayName = "ToolsIcon";
var ToolsIcon = ToolsIconDefinition;
var MembershipIconDefinition = function MembershipIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: membershipIcon,
    alt: "membership"
  }, props));
};
MembershipIconDefinition.displayName = "MembershipIcon";
var MembershipIcon = MembershipIconDefinition;
var AboutConsultantsIconDefinition = function AboutConsultantsIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: aboutConsultantsIcon,
    alt: "About Consultants"
  }, props));
};
AboutConsultantsIconDefinition.displayName = "AboutConsultantsIcon";
var AboutConsultantsIcon = AboutConsultantsIconDefinition;
var CaseStudiesIconDefinition = function CaseStudiesIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: caseStudiesIcon,
    alt: "Case Studies"
  }, props));
};
CaseStudiesIconDefinition.displayName = "CaseStudiesIcon";
var CaseStudiesIcon = CaseStudiesIconDefinition;
var ConnectCandidatesIconDefinition = function ConnectCandidatesIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: connectCandidatesIcon,
    alt: "Connect Candidates"
  }, props));
};
ConnectCandidatesIconDefinition.displayName = "ConnectCandidatesIcon";
var ConnectCandidatesIcon = ConnectCandidatesIconDefinition;
var EmployerResourcesIconDefinition = function EmployerResourcesIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: employerResourcesIcon,
    alt: "Employer Resources"
  }, props));
};
EmployerResourcesIconDefinition.displayName = "EmployerResourcesIcon";
var EmployerResourcesIcon = EmployerResourcesIconDefinition;
var BallIronIconDefinition = function BallIronIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: ballIronIcon,
    alt: "Ball Iron"
  }, props));
};
BallIronIconDefinition.displayName = "BallIronIcon";
var BallIronIcon = BallIronIconDefinition;
var WarningIconDefinition = function WarningIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: warningIcon,
    alt: "warning"
  }, props));
};
WarningIconDefinition.displayName = "WarningIcon";
var WarningIcon = WarningIconDefinition;
var CloseIconDefinition = function CloseIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: closeIcon,
    alt: "close"
  }, props));
};
CloseIconDefinition.displayName = "CloseIcon";
var CloseIcon = CloseIconDefinition;
var ExternalLinkIconDefinition = function ExternalLinkIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: externalLink,
    alt: "launch website"
  }, props));
};
ExternalLinkIconDefinition.displayName = "ExternalLinkIcon";
var ExternalLinkIcon = ExternalLinkIconDefinition;
var InstagramIconDefinition = function InstagramIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: instagramIcon,
    alt: "instagram"
  }, props));
};
InstagramIconDefinition.displayName = "InstagramIcon";
var InstagramIcon = InstagramIconDefinition;
var WebsiteIconDefinition = function WebsiteIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: websiteIcon,
    alt: "website"
  }, props));
};
WebsiteIconDefinition.displayName = "WebsiteIcon";
var WebsiteIcon = WebsiteIconDefinition;
var TrashIconDefinition = function TrashIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: trashIcon,
    alt: "Delete"
  }, props));
};
TrashIconDefinition.displayName = "TrashIcon";
var TrashIcon = TrashIconDefinition;
var InfoIconDefinition = function InfoIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: infoIcon,
    alt: "Info"
  }, props));
};
InfoIconDefinition.displayName = "InfoIcon";
var InfoIcon = InfoIconDefinition;
var CalendarIconDefinition = function CalendarIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: calendarIcon,
    alt: "calendar"
  }, props));
};
CalendarIconDefinition.displayName = "CalendarIcon";
var CalendarIcon = CalendarIconDefinition;
var ClockIconDefinition = function ClockIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: clockIcon,
    alt: "clock"
  }, props));
};
ClockIconDefinition.displayName = "ClockIcon";
var ClockIcon = ClockIconDefinition;
var GolfBallIconDefinition = function GolfBallIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: golfBallIcon,
    alt: "golf ball"
  }, props));
};
GolfBallIconDefinition.displayName = "GolfBallIcon";
var GolfBallIcon = GolfBallIconDefinition;
var GlobeIconDefinition = function GlobeIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: globeIcon,
    alt: "globe"
  }, props));
};
GlobeIconDefinition.displayName = "GlobeIcon";
var GlobeIcon = GlobeIconDefinition;
var EntryFeeDefinition = function EntryFeeDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: entryFeeIcon,
    alt: "entry fee"
  }, props));
};
EntryFeeDefinition.displayName = "EntryFeeIcon";
var EntryFeeIcon = EntryFeeDefinition;
var CaptionIconDefinition = function CaptionIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: captionIcon,
    alt: "caption"
  }, props));
};
CaptionIconDefinition.displayName = "CaptionIcon";
var CaptionIcon = CaptionIconDefinition;
var TrophyIconDefinition = function TrophyIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: trophyIcon,
    alt: "trophy"
  }, props));
};
TrophyIconDefinition.displayName = "TrophyIcon";
var TrophyIcon = TrophyIconDefinition;
var BackArrowDefinition = function BackArrowDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: backArrowIcon,
    alt: "back"
  }, props));
};
BackArrowDefinition.displayName = "BackArrowIcon";
var BackArrowIcon = BackArrowDefinition;
var successCheckmarkDefinition = function successCheckmarkDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: greenSuccess,
    alt: "success"
  }, props));
};
successCheckmarkDefinition.displayName = "SuccessCheckmarkIcon";
var SuccessCheckmarkIcon = successCheckmarkDefinition;
var playIconWhiteDefinition = function playIconWhiteDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: playIconWhite,
    alt: "play-icon-white"
  }, props));
};
playIconWhiteDefinition.displayName = "PlayIconWhiteIcon";
var PlayIconWhite = playIconWhiteDefinition;
var BriefcaseCheckDefinition = function BriefcaseCheckDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: briefcaseCheckIcon,
    alt: "briefcase-check"
  }, props));
};
BriefcaseCheckDefinition.displayName = "BriefcaseCheckIcon";
var BriefcaseCheckIcon = BriefcaseCheckDefinition;
var BriefcaseGolfDefinition = function BriefcaseGolfDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: briefcaseGolfIcon,
    alt: "briefcase-tea"
  }, props));
};
BriefcaseGolfDefinition.displayName = "BriefcaseGolfIcon";
var BriefcaseGolfIcon = BriefcaseGolfDefinition;
var preferencesDefinition = function preferencesDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: preferencesIcon,
    alt: "preferences"
  }, props));
};
preferencesDefinition.displayName = "PreferencesIcon";
var PreferencesIcon = preferencesDefinition;
var EmailErrorIconDefinition = function EmailErrorIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: emailErrorIco,
    alt: "email-error"
  }, props));
};
EmailErrorIconDefinition.displayName = "EmailErrorIcon";
var EmailErrorIcon = EmailErrorIconDefinition;
var EmailSentIconDefinition = function EmailSentIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: emailSentIco,
    alt: "email-sent"
  }, props));
};
EmailSentIconDefinition.displayName = "EmailSentIcon";
var EmailSentIcon = EmailSentIconDefinition;
var ErrorTriangleIconDefinition = function ErrorTriangleIconDefinition(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: errorTriangleIco,
    alt: "error-triangle"
  }, props));
};
ErrorTriangleIconDefinition.displayName = "ErrorTriangleIcon";
var ErrorTriangleIcon = ErrorTriangleIconDefinition;
var SearchJobsIconDef = function SearchJobsIconDef(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: searchJobsIcon,
    alt: "search"
  }, props));
};
SearchJobsIconDef.displayName = "SearchJobsIcon";
var SearchJobIcon = SearchJobsIconDef;
var ExecusearchIconDef = function ExecusearchIconDef(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: execusearchIcon,
    alt: "search"
  }, props));
};
ExecusearchIconDef.displayName = "ExecusearchIcon";
var ExecusearchIcon = ExecusearchIconDef;
var SearchIconBlueDef = function SearchIconBlueDef(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: searcIconhBlue,
    alt: "search"
  }, props));
};
SearchIconBlueDef.displayName = "SearchIconBlue";
var SearchIconBlue = SearchIconBlueDef;
var MeetTeamIconDef = function MeetTeamIconDef(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: meetTeamIcon,
    alt: "meet the team"
  }, props));
};
MeetTeamIconDef.displayName = "MeetTeamIcon";
var MeetTeamIcon = MeetTeamIconDef;
var OnlineEducationIconDef = function OnlineEducationIconDef(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: onlineEducationIcon,
    alt: "online education"
  }, props));
};
OnlineEducationIconDef.displayName = "OnlineEducationIcon";
var OnlineEducationIcon = OnlineEducationIconDef;
var GmailIconDef = function GmailIconDef(props) {
  return /*#__PURE__*/React__default.createElement(IcoSvg, _extends({
    src: gmailIcon,
    alt: "gmail"
  }, props));
};
GmailIconDef.displayName = "GmailIcon";
var GmailIcon = GmailIconDef;

export { AboutConsultantsIcon, AddressIcon, BackArrowIcon, BallIronIcon, BriefcaseCheckIcon, BriefcaseGolfIcon, CalendarIcon, CancelIcon, CaptionIcon, CaseStudiesIcon, ClockIcon, CloseIcon, ConnectCandidatesIcon, ContactIcon, EditIcon, EduIcon, EmailErrorIcon, EmailIcon, EmailSentIcon, EmployerResourcesIcon, EntryFeeIcon, ErrorTriangleIcon, ExecusearchIcon, ExternalLinkIcon, FbIcon, FlagIcon, GIcon, GlobeIcon, GmailIcon, GolfBallIcon, HamburgerIcon, InIcon, InfoIcon, InstagramIcon, LinkIcon, LocationIcon, MeetTeamIcon, MembershipIcon, OnlineEducationIcon, PlayIcon, PlayIconWhite, PreferencesIcon, SearchIcon, SearchIconBlue, SearchIconMobile, SearchJobIcon, ShopIcon, SuccessCheckmarkIcon, ToolsIcon, TrashIcon, TrophyIcon, TwitterIcon, UserIcon, VisibilityOnIcon, WarningIcon, WebsiteIcon, YoutubeIcon };
